import { useStytchWorkspaces } from '@/hooks/useStytchWorkspaces'
import {
	isWorkspaceSelectorOpen,
	setIsCreateWorkspaceDialogOpen,
	setIsWorkspaceSelectorOpen,
} from '@/redux/store/slices/ui/uiSlice'
import { Dialog } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@redux/hooks/useAppState'
import { useCallback } from 'react'

import { WorkspaceList } from '../WorkspaceList'

import type { FC } from 'react'

export const WorkspaceSelector: FC = () => {
	const { workspaces } = useStytchWorkspaces()
	const isOpen = useAppSelector(isWorkspaceSelectorOpen)
	const dispatch = useAppDispatch()

	const onClose = useCallback(() => {
		dispatch(setIsWorkspaceSelectorOpen(false))
	}, [dispatch])

	const onAddNew = () => {
		dispatch(setIsWorkspaceSelectorOpen(false))
		dispatch(setIsCreateWorkspaceDialogOpen(true))
	}

	return (
		<Dialog onClose={onClose} open={isOpen} fullWidth>
			<WorkspaceList workspaces={workspaces} onAddNew={onAddNew} onWorkspaceSelect={onClose} />
		</Dialog>
	)
}
